export default "__VITE_ASSET__BZOCQtvk__"